type Props = {
    className?: string
}

/**
 * Never wraps or shrinks: in a one-line truncating metadata row a wrapped
 * badge became a tall pill. On narrow cards it drops the ring and padding to
 * plain green text so it costs about 16px.
 */
export default function AdBadge({ className = '' }: Props) {
    return (
        <span
            data-tooltip-id="tooltip-id"
            data-tooltip-content="This comment is on a paid ad"
            className={`inline-flex shrink-0 items-center whitespace-nowrap text-xs font-medium text-green-700 @sm:rounded-md @sm:bg-green-50 @sm:px-1.5 @sm:py-0 @sm:ring-1 @sm:ring-inset @sm:ring-green-600/20 ${className}`}
        >
            Ad
        </span>
    )
}
